/**
 * Registros de formularios custom por módulo (importar una vez al arranque).
 */
import { registerDynamicForms as registerAlisofDynamicForms } from "@/modules/alisof_module/forms/registerDynamicForms";
import { registerDynamicForms as registerNegotiationDynamicForms } from "@/modules/negotiation_module/forms/registerDynamicForms";

registerAlisofDynamicForms();
registerNegotiationDynamicForms();
